import { enabledModules } from "@repo/module-kit"

import { articles } from "./articles/manifest"
import { bookings } from "./bookings/manifest"
import { clients } from "./clients/manifest"
import { home } from "./home/manifest"
import { docs } from "./docs/manifest"
import { contact } from "./contact/manifest"
import { invoicing } from "./invoicing/manifest"
import { legal } from "./legal/manifest"
import { links } from "./links/manifest"
import { media } from "./media/manifest"
import { projects } from "./projects/manifest"
import { seo } from "./seo/manifest"
import { settings } from "./settings/manifest"
import { testimonials } from "./testimonials/manifest"
import { website } from "./website/manifest"

/**
 * Every dashboard feature. Order here is nav and route order.
 *
 * Add a feature by writing its `manifest.ts` and listing it below. Switch
 * features off with `VITE_MODULES` (comma-separated ids; empty means all), and
 * keep it in step with the backend's `ENABLED_MODULES`.
 */
const allModules = [
  home,
  clients,
  bookings,
  website,
  projects,
  articles,
  testimonials,
  seo,
  legal,
  media,
  contact,
  links,
  invoicing,
  docs,
  settings,
]

export const dashboardModules = enabledModules(
  allModules,
  import.meta.env.VITE_MODULES as string | undefined
)
